/* PavCon, LLC Proprietary.All rights reserved 2022 */

import { AppSessionUser } from './shared/domain/app-session-user.entity';
import { Injectable } from '@angular/core';

/*
i. Admins: Have access to all bases and features
ii. MAJCOM: Have access to all features for a select group of UNIT(under their MAJCOM)
iii. DIT Manager: Has access to all features for one UNIT only. Is the User Administrator
    (i.e. keeping list of users accurate for that base)
iv. DIT Monitor: Has access to their shop at their UNIT in monitor review form,
    the change log and summary report for thier shops.
*/
@Injectable()
export class AppRoles {
  roles: Roles = {
    unauthorized: 'unauthorized',
    admin: 'admin',
    monitor: 'monitor',
    majcom: 'majcom',
    manager: 'manager',
    globalviewer: 'globalviewer',
  };
  levels = [
    { role: this.roles.unauthorized, level: 0 },
    { role: this.roles.monitor, level: 1 },
    { role: this.roles.manager, level: 2 },
    { role: this.roles.majcom, level: 3 },
    { role: this.roles.globalviewer, level: 4 }, // same level as admin for concurrency between pages access
    { role: this.roles.admin, level: 4 },
  ];
  isAuthorized(userRole: string, minRoleRequired: string) {
    const userLevel = this.levels.filter((l) => l.role === userRole)[0];
    const minLevel = this.levels.filter((l) => l.role === minRoleRequired)[0];
    return userLevel.level >= minLevel.level;
  }
  isUserAuthorized(user: AppSessionUser) {
    if (user) {
      if (user['custom:role'] === this.roles.unauthorized) {
        return 0;
      }
      return 1;
    }
    return -1;
  }
  isReadOnly(user: AppSessionUser) {
    if (user) {
      return user['custom:role'] === this.roles.globalviewer ||
        user['custom:role'] === this.roles.unauthorized
        ? true
        : false;
    }
    return true;
  }
}
export interface Roles {
  unauthorized: string;
  admin: string;
  monitor: string;
  majcom: string;
  manager: string;
  globalviewer: string;
}
